import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IProiect, IUser } from '../../proiecte.interface';
import { IDocument, IHistoryEntry } from './istoric-proiect.interface';
import { helper } from 'src/environments/helper';
import { ProiecteService } from '../../proiecte.service';
import { FormControl, FormGroup } from '@angular/forms';
import { AppFilesService } from 'src/app/services/app-files.service';

@Component({
    selector: 'app-istoric-proiect',
    templateUrl: './istoric-proiect.component.html',
    styleUrls: ['./istoric-proiect.component.scss']
})
export class IstoricProiectComponent implements OnInit, OnChanges {
    @Input() istoric!: IHistoryEntry[];
    @Input() user!: IUser;
    @Output() proiectChanged: EventEmitter<void> = new EventEmitter();
    @Output() isLoading = new EventEmitter<boolean>();
    helper = helper;
    filteredHistory!: IHistoryEntry[];

    passedProiectId!: number;

    messageTypes = [
        { key: '--Toate--', value: -1 },
        { key: 'Acțiuni Operator', value: 0 },
        { key: 'Informații Operator', value: 1 },
    ];

    searchParamsForm!: FormGroup;

    constructor(
        private proiecteService: ProiecteService,
        private appFileService: AppFilesService,
    ) { }

    ngOnInit(): void {
        this.initFilterForm();
        this.filterHistoryByType();
    }

    ngOnChanges(): void {
        this.filterHistoryByType();
    }

    initFilterForm() {
        this.searchParamsForm = new FormGroup({
            messageType: new FormControl(-1, []),
        });
    }

    filterHistoryByType() {
        const selectedType = this.searchParamsForm?.get('messageType')?.value as number;

        if (selectedType === -1) {
            this.filteredHistory = [...(this.istoric || [])];
        } else {
            this.filteredHistory = (this.istoric || []).filter(entry => entry.automated === selectedType);
        }
    }

    downloadDocument(id_document: number) {
        let fullPath = this.proiecteService.downloadDocumentURL + id_document;
        this.isLoading.emit(true);
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading.emit(false);
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading.emit(false);
            })
    }
}
